export const PRODUCT_UNITS = {
  kg: [
    {
      name: 'g',
      conversion: 1000
    }
  ],
  l: [
    {
      name: 'cl',
      conversion: 100
    }
  ]
};

export const PRODUCT_KEY_ID_SEPARATOR = '___';
export const SECTION_UPDATE_INTERVAL = 60000

export const KEY_PREFIX = {
  SECTION: 'SECTION_',
  PRODUCT: 'PRODUCT_',
  OPTION: 'OPTION_',
  ITEM: 'ITEM_',
};

export const OFFER_PRODUCT_KEY_SEPARATOR = '__';

export const OFFER_SECTION_KEY = 'OFFERS';
export const BNGM_PREFIX = 'BNGM';
export const BNGM_SECTION_KEY = 'BNGM_CAMPAIGN_PRODUCTS';
export const BNGM_SECTION_NAME = 'Produits de campagne BNGM';
export const BNGM_SLOT_SEPARATOR = '_SLOT_';
export const BNGM_DEFAULT_CAMPAIGN_NAME = 'Composez ton offre';
export const BNGM_SELECTION_CATEGORY_NAME = 'Choix des produits';
export const BNGM_PRODUCT_SELECTOR_NAME = 'Choisissez votre produit';
export const BNGM_FALLBACK_REVIEW_TITLE = 'Offre promotionnelle';
export const BNGM_INCOMPLETE_SELECTION_MESSAGE = 'Veuillez sélectionner tous les produits de l\'offre.';
export const BNGM_INCOMPATIBLE_SELECTION_MESSAGE = 'Impossible d\'ajouter cette offre au panier. Vérifiez que le menu du restaurant propose un produit compatible avec cette promotion.';

export const OFFER_SECTION = {
  description: "Retrouvez toutes nos offres du moment",
  position: 0,
  key: OFFER_SECTION_KEY,
  minimumPrice: 0,
  name: 'Nos Offres',
  iconUrl: '/assets/thresholdMarketing.png',
  hidden: false,
  products: {},
};
